import React, { useMemo } from "react";
import { Card, Col, OverlayTrigger, ProgressBar, Row, Tooltip, Table, Tab, Nav, Button } from 'react-bootstrap';
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import PageTitle from '../../includes/PageTitle';

function GlobalFilter({ globalFilter, setGlobalFilter }) {
    return (
        <span className="d-flex ms-auto">
            <input
                value={globalFilter || ""}
                onChange={(e) => setGlobalFilter(e.target.value)}
                className="form-control mb-4"
                placeholder="Search..."
            />
        </span>
    );
}






const Dashboard = () => {
    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
            },
            {
                Header: "Name",
                accessor: "name",
            },
            {
                Header: "Age",
                accessor: "age",
            },
            {
                Header: "Country",
                accessor: "country",
            },
        ],
        []
    );

    const data = useMemo(
        () => [
            { id: 1, name: "Piyush", age: 28, country: "India" },
            { id: 2, name: "Rahul", age: 32, country: "India" },
            { id: 3, name: "John", age: 26, country: "USA" },
            { id: 4, name: "Emma", age: 30, country: "UK" },
            { id: 5, name: "Sophia", age: 24, country: "Canada" },
            { id: 6, name: "Alex", age: 35, country: "Germany" },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,

        state,
        setGlobalFilter,

        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        gotoPage,
        pageCount,
        setPageSize,
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: 5 },
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const { globalFilter, pageIndex, pageSize } = state;
    return (
        <>
            <PageTitle titles="Dashboard" active="Dashboard" items={['Home']} />
            <Row>
                <Col lg={12} md={12} sm={12} xl={12}>
                    <Row>
                        <Col lg={6} md={6} sm={12} xl={3}>
                            <Card className="overflow-hidden">
                                <Card.Body>
                                    <div className="d-flex" >
                                        <div className="mt-2">
                                            <h6 className="">Total Users</h6>
                                            <h2 className="mb-0 number-font">44,278</h2>
                                        </div>
                                        <div className="ms-auto">
                                            <div className="chart-wrapper mt-1">
                                            </div>
                                        </div>
                                    </div>
                                    <span className="text-muted fs-12"><span className="text-secondary me-2"><i
                                        className="fe fe-arrow-up-circle  text-secondary"></i> 5%</span>
                                        Last week</span>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={6} md={6} sm={12} xl={3}>
                            <div className="card overflow-hidden">
                                <Card.Body>
                                    <div className="d-flex">
                                        <div className="mt-2">
                                            <h6 className="">Total Profit</h6>
                                            <h2 className="mb-0 number-font">67,987</h2>
                                        </div>
                                        <div className="ms-auto">
                                            <div className="chart-wrapper mt-1">
                                            </div>
                                        </div>
                                    </div>
                                    <span className="text-muted fs-12"><span className="text-pink me-2"><i
                                        className="fe fe-arrow-down-circle text-pink"></i> 0.75%</span>
                                        Last 6 days</span>
                                </Card.Body>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xl={3}>
                            <div className="card overflow-hidden">
                                <Card.Body>
                                    <div className="d-flex">
                                        <div className="mt-2">
                                            <h6 className="">Total Expenses</h6>
                                            <h2 className="mb-0 number-font">$76,965</h2>
                                        </div>
                                        <div className="ms-auto">
                                            <div className="chart-wrapper mt-1">
                                            </div>
                                        </div>
                                    </div>
                                    <span className="text-muted fs-12"><span className="text-green me-2"><i
                                        className="fe fe-arrow-up-circle text-green"></i> 0.9%</span>
                                        Last 9 days</span>
                                </Card.Body>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xl={3}>
                            <Card className="overflow-hidden">
                                <Card.Body>
                                    <div className="d-flex">
                                        <div className="mt-2">
                                            <h6 className="">Total Cost</h6>
                                            <h2 className="mb-0 number-font">$59,765</h2>
                                        </div>
                                        <div className="ms-auto">
                                            <div className="chart-wrapper mt-1">
                                            </div>
                                        </div>
                                    </div>
                                    <span className="text-muted fs-12"><span className="text-warning me-2"><i
                                        className="fe fe-arrow-up-circle text-warning"></i> 0.6%</span>
                                        Last year</span>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col sm={12} className="col-12">
                    <Card>
                        <Card.Header>
                            <h4 className="card-title">Product Summary</h4>
                        </Card.Header>
                        <Card.Body>
                            <Tab.Container id="left-tabs-example" defaultActiveKey="AllProducts">
                                <Nav variant="pills" className='product-sale'>
                                    <Nav.Item>
                                        <Nav.Link eventKey="AllProducts" className="text-dark">All Products</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="Shipped" className="text-dark">Shipped</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="Pending" className="text-dark">Pending</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="Cancelled" className="text-dark">Cancelled</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <Tab.Content>
                                    <Tab.Pane eventKey="AllProducts">
                                        <Card.Body className="pt-0 example1-table">
                                            <div className="table-responsive">
                                                <div className="d-flex">
                                                    <select
                                                        className=" mb-4 selectpage border me-1"
                                                        value={pageSize}
                                                        onChange={(e) => setPageSize(Number(e.target.value))}
                                                    >
                                                        {[5, 10, 15, 20, 25, 50].map((pageSize) => (
                                                            <option key={pageSize} value={pageSize}>
                                                                Show {pageSize}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <GlobalFilter
                                                        globalFilter={globalFilter}
                                                        setGlobalFilter={setGlobalFilter}
                                                    />
                                                </div>

                                                <table
                                                    {...getTableProps()}
                                                    className="table table-bordered text-nowrap mb-0"
                                                >
                                                    <thead>
                                                        {headerGroups.map((headerGroup) => (
                                                            <tr className="text-center" {...headerGroup.getHeaderGroupProps()}>
                                                                {headerGroup.headers.map((column) => (
                                                                    <th
                                                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                                                        className={column.className}
                                                                        key={Math.random()}
                                                                    >
                                                                        <span className="tabletitle">{column.render("Header")}</span>
                                                                        <span>
                                                                            {column.isSorted ? (
                                                                                column.isSortedDesc ? (
                                                                                    <i className="fa fa-angle-down"></i>
                                                                                ) : (
                                                                                    <i className="fa fa-angle-up"></i>
                                                                                )
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </span>
                                                                    </th>
                                                                ))}
                                                            </tr>
                                                        ))}
                                                    </thead>

                                                    <tbody {...getTableBodyProps()}>
                                                        {page.map((row) => {
                                                            prepareRow(row);
                                                            return (
                                                                <tr className="text-center" {...row.getRowProps()}>
                                                                    {row.cells.map((cell) => (
                                                                        <td {...cell.getCellProps()} key={Math.random()}>{cell.render("Cell")}</td>
                                                                    ))}
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                                <div className="d-block d-sm-flex mt-4 align-items-center">
                                                    <span className="">
                                                        Page{" "}
                                                        <strong>
                                                            {pageIndex + 1} of {pageOptions.length}
                                                        </strong>{" "}
                                                    </span>
                                                    <span className="ms-sm-auto">
                                                        <Button
                                                            variant=""
                                                            className="btn-default tablebutton me-2 d-sm-inline d-block my-1"
                                                            onClick={() => gotoPage(0)}
                                                            disabled={!canPreviousPage}
                                                        >
                                                            {" Previous "}
                                                        </Button>
                                                        <Button
                                                            variant=""
                                                            className="btn-default tablebutton me-2 my-1"
                                                            onClick={() => {
                                                                previousPage();
                                                            }}
                                                            disabled={!canPreviousPage}
                                                        >
                                                            {" << "}
                                                        </Button>
                                                        <Button
                                                            variant=""
                                                            className="btn-default tablebutton me-2 my-1"
                                                            onClick={() => {
                                                                previousPage();
                                                            }}
                                                            disabled={!canPreviousPage}
                                                        >
                                                            {" < "}
                                                        </Button>
                                                        <Button
                                                            variant=""
                                                            className="btn-default tablebutton me-2 my-1"
                                                            onClick={() => {
                                                                nextPage();
                                                            }}
                                                            disabled={!canNextPage}
                                                        >
                                                            {" > "}
                                                        </Button>
                                                        <Button
                                                            variant=""
                                                            className="btn-default tablebutton me-2 my-1"
                                                            onClick={() => {
                                                                nextPage();
                                                            }}
                                                            disabled={!canNextPage}
                                                        >
                                                            {" >> "}
                                                        </Button>
                                                        <Button
                                                            variant=""
                                                            className="btn-default tablebutton me-2 d-sm-inline d-block my-1"
                                                            onClick={() => gotoPage(pageCount - 1)}
                                                            disabled={!canNextPage}
                                                        >
                                                            {" Next "}
                                                        </Button>
                                                    </span>
                                                </div>


                                                {/* <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                    <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                                                        ⏮ First
                                                    </button>
                                                    <button onClick={previousPage} disabled={!canPreviousPage}>
                                                        ◀ Prev
                                                    </button>
                                                    <button onClick={nextPage} disabled={!canNextPage}>
                                                        Next ▶
                                                    </button>
                                                    <button
                                                        onClick={() => gotoPage(pageOptions.length - 1)}
                                                        disabled={!canNextPage}
                                                    >
                                                        Last ⏭
                                                    </button>

                                                    <span>
                                                        Page <strong>{pageIndex + 1}</strong> of{" "}
                                                        <strong>{pageOptions.length}</strong>
                                                    </span>


                                                </div> */}

                                            </div>
                                        </Card.Body>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="Shipped">

                                    </Tab.Pane>
                                    <Tab.Pane eventKey="Pending">

                                    </Tab.Pane>
                                    <Tab.Pane eventKey="Cancelled">

                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default Dashboard